module.exports = __webpack_public_path__ + "img/mb-nav-logo.dc17198.webp";